import { render } from "./ForgotPassword.vue?vue&type=template&id=2bf91cf6"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/auth/components/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bf91cf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bf91cf6', __exports__)) {
    api.reload('2bf91cf6', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=2bf91cf6", () => {
    api.rerender('2bf91cf6', render)
  })

}


export default __exports__